import { render, staticRenderFns } from "./ntmListItem.vue?vue&type=template&id=1886cd56"
import script from "./ntmListItem.vue?vue&type=script&lang=js"
export * from "./ntmListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports